<template>
  <div class="tab-content leaderboard-content">
    <div class="button-tab-wrapper py-4">
      <v-btn-toggle v-model="leaderBoardTab">
        <v-btn to="/app/dashboard/leaderboard" exact flat>Group</v-btn>
        <v-btn
          to="/app/dashboard/leaderboard/continent"
          ref="continentTab"
          exact
          flat
          >Continent</v-btn
        >
        <v-btn to="/app/dashboard/leaderboard/global" exact flat>Global</v-btn>
        <v-btn to="/app/dashboard/leaderboard/monthly-winners" exact flat
          >Monthly Winners</v-btn
        >
      </v-btn-toggle>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data: () => ({
    leaderBoardTab: null
  }),
  activated() {
    const userObj = JSON.parse(localStorage.getItem('user'))
    this.$refs.continentTab.$el.innerText = `Continent (${userObj.continent})`
  }
}
</script>

<style lang="scss">
.leaderboard-content {
  height: 100%;

  .button-tab-wrapper {
    .v-item-group {
      width: 100%;
      border-radius: 5px;
      box-shadow: none;

      .v-btn {
        border-right: 1px solid $primary-background-color;
        text-transform: capitalize;
        font-size: 12px;

        &:first-child {
          border-radius: 5px 0 0 5px;
        }

        &:last-child {
          border-radius: 0 5px 5px 0;
          border: 0;
        }

        &--active {
          background-color: $primary-color !important;
        }
      }
    }
  }
}
</style>
